module.exports = __webpack_public_path__ + "img/level-icon-1.98bc497e.png";